import { Link } from 'react-router';
import { SearchableSelect } from '../../../components/SearchableSelect';
import { getAdminCompanyDetailPath, getAdminImportDetailPath } from '../adminRoutes';
import { useCatalogProductOffers } from './useCatalogRelatedLists';
import { CatalogRequestState } from './CatalogRequestState';
import { CatalogPagination } from './CatalogPagination';
import { catalogDate, catalogPrice, catalogQuantity } from './catalogDisplay';

const availabilityOptions = [{ value: '', label: 'Все предложения' }, { value: 'available', label: 'В наличии' }, { value: 'unavailable', label: 'Нет в наличии' }];

export function CatalogProductOffers({ productId, unit }: { productId: number; unit: string }) {
  const { query, page, setPage, availability, changeAvailability } = useCatalogProductOffers(productId);
  return (
    <section className="catalog-content-section" id="offers" aria-labelledby="offers-title">
      <header className="catalog-section-heading"><div><h2 id="offers-title">Предложения поставщиков {query.data?.meta.total !== undefined ? <span>{query.data.meta.total}</span> : null}</h2><p>Цена, минимальный заказ и наличие у каждого поставщика.</p></div><div className="catalog-offer-filter"><SearchableSelect inputId="offer-availability" ariaLabel="Наличие у поставщика" options={availabilityOptions} value={availability} onChange={changeAvailability} placeholder="Все предложения" /></div></header>
      {query.isPending || query.isError ? <CatalogRequestState error={query.error?.message} onRetry={() => { void query.refetch(); }} /> : query.data.items.length === 0 ? <div className="catalog-empty"><h3>Предложений пока нет</h3><p>{availability ? 'Измените фильтр наличия, чтобы увидеть остальные предложения.' : 'Предложения появятся после импорта и сопоставления прайсов поставщиков.'}</p>{availability ? <button className="catalog-button" type="button" onClick={() => changeAvailability('')}>Показать все предложения</button> : null}</div> : (
        <>
          <div className="catalog-data-scroll" tabIndex={0} aria-label="Предложения поставщиков">
            <table className="catalog-data-table"><thead><tr><th>Поставщик / товар</th><th>Цена за {unit}</th><th>Мин. заказ</th><th>Наличие</th><th>Обновлено</th></tr></thead><tbody>
              {query.data.items.map((offer) => {
                const companyPath = getAdminCompanyDetailPath(offer.company_id);
                const importId = offer.offer_import_id;
                const importPath = importId === null || importId === undefined ? null : getAdminImportDetailPath(importId);

                return (
                  <tr key={offer.offer_id}>
                    <td>
                      <Link to={companyPath}>{offer.company_name}</Link>
                      <p>{offer.supplier_product_name || offer.product_name}</p>
                      <small>{offer.supplier_product_sku}</small>
                      {importPath !== null ? <Link to={importPath}>Прайс #{importId}</Link> : null}
                    </td>
                    <td className="catalog-price">{catalogPrice(offer.offer_price)}</td>
                    <td>{catalogQuantity(offer.offer_min_quantity)} {unit}</td>
                    <td><span className={offer.offer_availability ? 'catalog-stock is-available' : 'catalog-stock'}>{offer.offer_availability ? 'В наличии' : 'Нет в наличии'}</span></td>
                    <td>{catalogDate(offer.offer_updated_at)}</td>
                  </tr>
                );
              })}
            </tbody></table>
          </div>
          <CatalogPagination page={page} pageCount={query.data.meta.page_count ?? 1} onChange={setPage} />
        </>
      )}
    </section>
  );
}
